import * as React from "react";
import * as ReactDOM from "react-dom";
export function usePortal({ key, source, target }) {
    return React.useMemo(function createPortal() {
        if (!target)
            return null;
        return ReactDOM.createPortal(source, target, key);
    }, [key, source, target]);
}
